var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback, useMemo, useRef, useState } from 'react';
import { apiUpdateProffitSearchFolderRename } from '../../../../actions/ProffitSearchFolderAction';
import { notify, wrapDispatch, wrapNotifyError } from '../../../action';
import { useBoolState } from '../../useHook';
/**
 * フォルダ名のリネーム処理を制御するuse
 * @param unmountRef
 * @param folder
 * @returns {{onSubmit: ((function(*): Promise<void>)|*)}}
 */
const useMyPageFolderRenameForm = (unmountRef, folder) => {
    const { id, name: initialName } = folder;
    const [name, changeName] = useState(initialName || '');
    const inputRef = useRef();
    /**
     * フォームの表示を制御
     */
    const { boolState: isShowForm, changeFalse: rawHideForm, changeTrue: showForm, } = useBoolState(false);
    /**
     * ツールチップの表示を制御
     */
    const { boolState: isShowTooltip, changeFalse: hideTooltip, changeTrue: showTooltip, } = useBoolState(false);
    /**
     * フォームが非表示になったらツールチップも非表示にする
     * @type {(function(): void)|*}
     */
    const hideForm = useCallback(() => {
        rawHideForm();
        hideTooltip();
    }, [rawHideForm, hideTooltip]);
    /**
     * フォルダ名更新APIを実行
     * @type {(function(*=, *=, *): Promise<void>)|*}
     */
    const onSubmit = useCallback((formValues, formDispatch, formProps) => __awaiter(void 0, void 0, void 0, function* () {
        const { name: inputName } = formValues;
        const { initialValues: inputInitialValues } = formProps;
        // 入力値が存在しない、もしくは初期値と変わらない場合は更新を行わない
        if (inputName === '' || inputInitialValues.name === inputName) {
            hideForm();
            return;
        }
        yield wrapNotifyError(() => __awaiter(void 0, void 0, void 0, function* () {
            yield wrapDispatch(formDispatch, apiUpdateProffitSearchFolderRename(id, formValues, Object.assign({ id }, formValues)));
            if (!unmountRef.current) {
                changeName(formValues.name);
                hideForm();
                notify('フォルダ名を更新しました');
            }
        }));
    }), [changeName, hideForm, id, unmountRef]);
    /**
     * テキスト表示時にマウスオーバーでツールチップを表示させる
     * @type {(function(*): void)|*}
     */
    const onMouseEnter = useCallback((e) => {
        const { clientWidth, scrollWidth } = e.currentTarget;
        if (scrollWidth > clientWidth) {
            showTooltip();
        }
    }, [showTooltip]);
    const initialValues = useMemo(() => ({
        name,
    }), [name]);
    return {
        hideForm,
        hideTooltip,
        initialValues,
        inputRef,
        isShowForm,
        isShowTooltip,
        name,
        onMouseEnter,
        onSubmit,
        showForm,
    };
};
export const useMyPageFolderRename = {
    useMyPageFolderRenameForm,
};
export default useMyPageFolderRename;
